<template>
  <div class="preview-pdf">
    <el-dialog
      :title="previewData.originalName"
      :visible.sync="previewPdfDialogVisible"
      :fullscreen="true"
      :before-close="handleClose"
      :append-to-body="true"
    >
      <div class="preview">
        <!-- pdfjs预览插件 -->
        <iframe
          id="iframe1"
          :src="`${ getFile() }`"
          style="width: 100%; min-height: 100vh"
          scrolling="no"
        >
          您的浏览器不支持PDF阅读
        </iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import urls from '@/utils/baseUrl'
import { onlineUrl } from '@/utils/config.js'
export default {
  props: {
    previewPdfDialogVisible: {
      default: false,
      type: Boolean,
    },
    previewData:{
      default: {},
      type: Object,
    },
    pdfUrl:{
      default:'',
      type:String
    },
  },
  data() {
    return {
      // serverCommon:urls.baseUrl,
      // serverHost:urls.oss_url,
      onlineUrl:onlineUrl
    }
  },
  methods: {
    getFile() {
      return this.pdfUrl
    },
    handleClose(){
      this.$emit("closePreviewPdf");
    }
  },
  mounted() {
  },
}
</script>

<style lang="scss">
.preview {
  height: 100vh;
  overflow: hidden;
}
.preview-pdf {
  .el-dialog {
    margin-top: 0 !important;
  }
  .el-dialog__close {
    font-size: 25px;
  }
}
</style>
